import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { VehicleDetailView } from "@/views/vehicle-detail/vehicle-detail.view";
import { VehicleVinRedirectView } from "@/views/vehicle-detail/vehicle-vin-redirect.view";
import { Route, Switch } from "wouter";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";
import { VehicleView } from "./vehicle.view";

export function VehicleRoutes() {
  const ability = useAbility();
  const vehicleUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const vehicleDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Vehicle");

  return (
    <Switch>
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={vehicleUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={vehicleDetailUuidRegex} component={VehicleDetailView} />
      <Route path={"/:vin"} component={VehicleVinRedirectView} />
      <Route path={"/"} component={VehicleView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
